import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import baseURL from "../url";
import "./Cart.css";
import whatsappIcon from "../../images/wpp.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faShoppingCart,
  faTrash,
  faUser,
  faPhone,
  faIdCard,
  faMapMarkerAlt,
  faBuilding,
  faCity,
  faTag,
} from "@fortawesome/free-solid-svg-icons";
import { Link as Anchor } from "react-router-dom";
import moneda from "../moneda";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
export default function Cart() {
  const [name, setName] = useState("");
  const [telefono, setTelefono] = useState("");
  const [dni, setDni] = useState("");
  const [deliveryOption, setDeliveryOption] = useState("deliveryLima"); // "deliveryLima" or "envioProvincia"
  const [addressLima, setAddressLima] = useState("");
  const [distrito, setDistrito] = useState("");
  const [provincia, setProvincia] = useState("");
  const [agenciaSucursal, setAgenciaSucursal] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("contraentrega"); // "contraentrega" or "transferencia"
  const [codigoDescuento, setCodigoDescuento] = useState("");
  const [codigo, setCodigo] = useState("");
  const [noteText, setNoteText] = useState("");
  const [cartItems, setCartItems] = useState([]);
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpen2, setModalIsOpen2] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [contactos, setContactos] = useState([]);
  const [descuento, setDescuento] = useState(0);
  const [codigoValido, setCodigoValido] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  useEffect(() => {
    cargarContacto();
  }, []);
  useEffect(() => {
    // Calcular el precio total al cargar el carrito o al actualizar los productos
    let totalPriceCalc = 0;
    cartItems.forEach((item) => {
      totalPriceCalc += item.precio * item.cantidad;
    });
    setTotalPrice(totalPriceCalc);
  }, [cartItems]);

  const cargarContacto = () => {
    fetch(`${baseURL}/contactoGet.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        setContactos(data.contacto.reverse()[0] || []);
      })
      .catch((error) => console.error("Error al cargar contactos:", error));
  };

  useEffect(() => {
    cargarProductos();
  }, [isFocused]);

  useEffect(() => {
    const fetchCartItems = async () => {
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      const promises = cart.map(async (cartItem) => {
        const producto = productos.find(
          (producto) => producto.idProducto === cartItem.idProducto
        );
        return {
          ...producto,
          cantidad: cartItem.cantidad,
          item: cartItem.item,
        };
      });

      Promise.all(promises)
        .then((items) => {
          setCartItems(items);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error al obtener detalles del carrito:", error);
          setLoading(false);
        });
    };

    fetchCartItems();
  }, [productos, isFocused]);

  const cargarProductos = () => {
    fetch(`${baseURL}/productosGet.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        setProductos(data.productos || []);
      })
      .catch((error) => console.error("Error al cargar productos:", error));
  };

  const obtenerImagen = (item) => {
    return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
  };

  const openModal = () => {
    setModalIsOpen(true);
    setIsFocused(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setIsFocused(false);
  };

  const openModal2 = () => {
    setModalIsOpen2(true);
  };

  const closeModal2 = () => {
    setModalIsOpen2(false);
  };

  const removeFromCart = (id) => {
    const updatedCart = cartItems.filter((item) => item.idProducto !== id);
    setCartItems(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem("cart");
  };

  const [codigos, setCodigos] = useState([]);

  useEffect(() => {
    cargarCodigos();
  }, []);

  const cargarCodigos = () => {
    fetch(`${baseURL}/codigosGet.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        setCodigos(data.codigos || []);
      })
      .catch((error) => console.error("Error al cargar códigos:", error));
  };

  const handleWhatsappMessage = () => {
    const codigoDescuentoObj = codigos.find(
      (item) => item.codigo === codigoDescuento
    );
    let descuentoActualizado = 0;

    if (codigoDescuentoObj) {
      descuentoActualizado = codigoDescuentoObj.descuento;
      setCodigoValido(true);
    } else {
      setCodigoValido(false);
    }

    let totalPrice = 0;

    cartItems.forEach((item) => {
      totalPrice += item.precio * item.cantidad;
    });

    let totalPriceWithDiscount = totalPrice - descuentoActualizado;
    if (totalPriceWithDiscount < 0) {
      totalPriceWithDiscount = 0;
    }

    const formattedTotalPrice = totalPriceWithDiscount
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const phoneNumber = `${contactos.telefono}`;

    const cartDetails = cartItems.map(
      (item) =>
        `\n✅ *${item.titulo}* \n       Cantidad: ${
          item.cantidad
        }\n       Precio: ${moneda} ${item.precio
          ?.toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")} \n       ${item?.item}`
    );

    let noteMessage = "";

    if (name.trim() !== "") {
      noteMessage += `\n✅ Nombre y Apellido: ${name}`;
    }
    if (telefono.trim() !== "") {
      noteMessage += `\n✅ Teléfono: ${telefono}`;
    }
    if (dni.trim() !== "" && deliveryOption === "envioProvincia") {
      noteMessage += `\n✅ DNI: ${dni}`;
    }

    let entregaMessage = "";
    if (deliveryOption === "deliveryLima") {
      entregaMessage = `\n✅ Delivery Lima: ${addressLima}, Distrito: ${distrito}`;
    } else if (deliveryOption === "envioProvincia") {
      entregaMessage = `\n✅ Envío a Provincia: ${provincia}, Agencia/Sucursal: ${agenciaSucursal}`;
    }

    if (noteText.trim() !== "") {
      noteMessage += `\n✅ Nota: ${noteText}`;
    }

    if (codigoDescuento.trim() !== "") {
      noteMessage += `\n✅ Cód. Descuento: ${codigoDescuento}\n✅ Descuento de : ${moneda} ${descuentoActualizado
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
    }

    const paymentMessage =
      paymentMethod === "contraentrega"
        ? "Pago: Contraentrega (COD)"
        : "Pago: Yape / Plin";

    const message = `¡Hola! 🌟 Estoy interesado en realizar el siguiente pedido:\n${cartDetails.join(
      ""
    )}\n------------------------------------>\n ${noteMessage}${entregaMessage}\n✅ ${paymentMessage}\n\n------------------------------------>\n\n*Total: ${moneda} ${formattedTotalPrice}*`;

    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappUrl, "_blank");
    setName("");
    setTelefono("");
    setDni("");
    setAddressLima("");
    setDistrito("");
    setProvincia("");
    setAgenciaSucursal("");
    setCodigoDescuento("");
    setNoteText("");
    setDescuento(descuentoActualizado);
    setModalIsOpen(false);
    setModalIsOpen2(false);
  };

  // Función para aumentar la cantidad de un producto en el carrito
  const increaseQuantity = (index) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems[index].cantidad += 1;
    setCartItems(updatedCartItems);
    localStorage.setItem("cart", JSON.stringify(updatedCartItems));
  };

  // Función para disminuir la cantidad de un producto en el carrito
  const decreaseQuantity = (index) => {
    const updatedCartItems = [...cartItems];
    if (updatedCartItems[index].cantidad > 1) {
      updatedCartItems[index].cantidad -= 1;
      setCartItems(updatedCartItems);
      localStorage.setItem("cart", JSON.stringify(updatedCartItems));
    }
  };

  //pedido-------------------------------------------------------------------
  const [mensaje, setMensaje] = useState("");
  const crearPedido = async () => {
    setMensaje("Procesando...");

    try {
      // Construir la lista de productos del pedido
      const productosPedido = cartItems?.map((item) => {
        return {
          titulo: item?.titulo,
          cantidad: item?.cantidad,
          item: item?.item,
          precio: item?.precio,
          imagen: obtenerImagen(item),
        };
      });
      // Convertir la lista de productos a JSON
      const productosPedidoJSON = JSON.stringify(productosPedido);
      // Calcular el precio total del pedido
      let totalPrice = 0;
      cartItems.forEach((item) => {
        totalPrice += item?.precio * item?.cantidad;
      });

      // Obtener el descuento del código de descuento
      const codigoDescuento = codigos?.find((item) => item?.codigo === codigo);
      let descuentoCodigo = 0;

      if (codigoDescuento) {
        descuentoCodigo = codigoDescuento?.descuento;
      }

      // Aplicar el descuento del código de descuento
      const totalPriceWithDiscount = totalPrice - descuentoCodigo;

      // Enviar el pedido con el precio total descontado
      const formData = new FormData();

      formData.append("productos", productosPedidoJSON);
      formData.append("total", totalPriceWithDiscount);
      formData.append("nombre", name);
      formData.append("telefono", telefono);
      formData.append("dni", dni);

      formData.append("opcion_entrega", deliveryOption);
      if (deliveryOption === "deliveryLima") {
        formData.append("direccion_completa", addressLima);
        formData.append("distrito", distrito);
      } else if (deliveryOption === "envioProvincia") {
        formData.append("provincia", provincia);
        formData.append("agencia_sucursal", agenciaSucursal);
      }

      formData.append("pago", paymentMethod);
      formData.append("nota", noteText);
      formData.append("codigo", codigo);
      formData.append("estado", "Pendiente");
      const response = await fetch(`${baseURL}/pedidoPost.php`, {
        method: "POST",
        body: formData,
      });
      // console.log(entrega);
      const data = await response.json();
      if (data.mensaje) {
        setMensaje("");
        Swal.fire("Pedido enviado!", data.mensaje, "success");
        setName("");
        setCodigo("");
        setNoteText("");
        closeModal();
        closeModal2();
        clearCart();
        handleWhatsappMessage();
      } else if (data?.error) {
        setMensaje("");
        Swal.fire("Error", data?.error, "error");
      }
    } catch (error) {
      console.error("Error:", error);
      setMensaje("");
      Swal.fire(
        "Error",
        "Error de conexión. Por favor, inténtelo de nuevo.",
        "error"
      );
    }
  };
  return (
    <div>
      <ToastContainer />
      <button onClick={openModal} className="cartIconFixed">
        {cartItems?.length >= 1 && <span>{cartItems.length}</span>}
        <FontAwesomeIcon icon={faShoppingCart} />
      </button>

      <Modal
        isOpen={modalIsOpen}
        className="modal-cart"
        overlayClassName="overlay-cart"
        onRequestClose={closeModal}
      >
        <div className="deFLex">
          <button onClick={closeModal}>
            <FontAwesomeIcon icon={faArrowLeft} />{" "}
          </button>
          <button onClick={clearCart} className="deleteToCart">
            Vaciar carrito
          </button>
        </div>
        {cartItems?.length === 0 ? (
          <p className="nohay"> No hay productos</p>
        ) : (
          <>
            <div className="modal-content-cart">
              {loading ? (
                <p>Cargando...</p>
              ) : (
                <div>
                  {cartItems.map((item, index) => (
                    <div key={item?.idProducto} className="cardProductCart">
                      <Anchor
                        to={`/producto/${
                          item?.idProducto
                        }/${item?.titulo?.replace(/\s+/g, "-")}`}
                        onClick={closeModal}
                      >
                        <img src={obtenerImagen(item)} alt="imagen" />
                      </Anchor>
                      <div className="cardProductCartText">
                        <h3>{item.titulo}</h3>
                        <span>
                          {item?.item?.map((sabor, index) => (
                            <span key={index}> {sabor}</span>
                          ))}
                        </span>
                        <strong>
                          {moneda}{" "}
                          {item?.precio
                            ?.toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                        </strong>
                      </div>
                      <div className="deColumn">
                        <button
                          onClick={() => removeFromCart(item.idProducto)}
                          className="deleteCart"
                        >
                          {" "}
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                        <div className="deFlexCantidad">
                          <button onClick={() => decreaseQuantity(index)}>
                            -
                          </button>
                          <span>{item.cantidad}</span>
                          <button onClick={() => increaseQuantity(index)}>
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="deColumnCart">
              <h4>
                Total: {moneda}{" "}
                {totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
              </h4>

              <div className="deFLexBtns">
                <button className="btnWpp" onClick={openModal2}>
                  Pedir por WhatsApp
                  <img src={whatsappIcon} alt="WhatsApp" />
                </button>
              </div>
            </div>

            <Modal
              isOpen={modalIsOpen2}
              onRequestClose={closeModal2}
              className="modal-cart"
              overlayClassName="overlay-cart"
            >
              <div className="deFLex">
                <button onClick={closeModal2}>
                  <FontAwesomeIcon icon={faArrowLeft} />{" "}
                </button>
                <h4>Agregar Detalles</h4>
              </div>
              <div className="modal-send-form">
                {/* General Information Fields */}
                <div className="field-container">
                  <label htmlFor="name">
                    Nombre y Apellido
                    <span class="flag-campo-obligatorio"> *</span>
                  </label>
                  <div className="input-group">
                    <div className="icon-block">
                      <FontAwesomeIcon icon={faUser} />
                    </div>
                    <input
                      type="text"
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Nombre y Apellido"
                      required
                    />
                  </div>
                </div>
                <div className="field-container">
                  <label htmlFor="telefono">
                    Teléfono<span class="flag-campo-obligatorio"> *</span>
                  </label>
                  <div className="input-group">
                    <div className="icon-block">
                      <FontAwesomeIcon icon={faPhone} />
                    </div>
                    <input
                      type="number"
                      id="telefono"
                      value={telefono}
                      onChange={(e) => setTelefono(e.target.value)}
                      placeholder="Ingresa tu teléfono"
                      required
                    />
                  </div>
                </div>
                <div className="field-container">
                  <label htmlFor="dni">DNI (Provincia)</label>
                  <div className="input-group">
                    <div className="icon-block">
                      <FontAwesomeIcon icon={faIdCard} />
                    </div>
                    <input
                      type="text"
                      id="dni"
                      value={dni}
                      onChange={(e) => setDni(e.target.value)}
                      placeholder="En caso sea envío"
                      required={deliveryOption === "envioProvincia"}
                    />
                  </div>
                </div>

                {/* Delivery Options Section */}
                <div className="deFLexRadio">
                  <label>Opciones de entrega</label>
                  <div>
                    <input
                      type="radio"
                      id="deliveryLima"
                      name="deliveryOption"
                      value="deliveryLima"
                      checked={deliveryOption === "deliveryLima"}
                      onChange={() => setDeliveryOption("deliveryLima")}
                    />
                    <label htmlFor="deliveryLima">Delivery Lima</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="envioProvincia"
                      name="deliveryOption"
                      value="envioProvincia"
                      checked={deliveryOption === "envioProvincia"}
                      onChange={() => {
                        setPaymentMethod("yape/plin");
                        setDeliveryOption("envioProvincia");
                      }}
                    />
                    <label htmlFor="envioProvincia">Envío a Provincia</label>
                  </div>
                </div>

                {/* Dynamic Address Block */}
                {deliveryOption === "deliveryLima" && (
                  <>
                    <div className="field-container">
                      <label htmlFor="addressLima">
                        Dirección<span class="flag-campo-obligatorio"> *</span>
                      </label>
                      <div id="address-group" className="input-group">
                        <div className="icon-block">
                          <FontAwesomeIcon icon={faMapMarkerAlt} />
                        </div>
                        <input
                          type="text"
                          id="addressLima"
                          value={addressLima}
                          onChange={(e) => setAddressLima(e.target.value)}
                          placeholder="Dirección completa"
                          required
                        />
                      </div>
                    </div>
                    <div className="field-container">
                      <label htmlFor="distrito">
                        Distrito<span class="flag-campo-obligatorio"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="icon-block">
                          <FontAwesomeIcon icon={faCity} />
                        </div>
                        <input
                          type="text"
                          id="distrito"
                          value={distrito}
                          onChange={(e) => setDistrito(e.target.value)}
                          placeholder="Distrito"
                          required
                        />
                      </div>
                    </div>
                  </>
                )}
                {deliveryOption === "envioProvincia" && (
                  <>
                    <div className="field-container">
                      <label htmlFor="provincia">
                        Provincia<span class="flag-campo-obligatorio"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="icon-block">
                          <FontAwesomeIcon icon={faMapMarkerAlt} />
                        </div>
                        <input
                          type="text"
                          id="provincia"
                          value={provincia}
                          onChange={(e) => setProvincia(e.target.value)}
                          placeholder="Provincia"
                          required
                        />
                      </div>
                    </div>
                    <div className="field-container">
                      <label htmlFor="agenciaSucursal">
                        Agencia + Sucursal
                        <span class="flag-campo-obligatorio"> *</span>
                      </label>
                      <div className="input-group">
                        <div className="icon-block">
                          <FontAwesomeIcon icon={faBuilding} />
                        </div>
                        <input
                          type="text"
                          id="agenciaSucursal"
                          value={agenciaSucursal}
                          onChange={(e) => setAgenciaSucursal(e.target.value)}
                          placeholder="Agencia + Sucursal"
                          required
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* Payment Methods Section */}
                <div className="deFLexRadio">
                  <label>Métodos de pago</label>
                  <div>
                    <input
                      type="radio"
                      id="contraentrega"
                      name="paymentMethod"
                      value="contraentrega"
                      checked={paymentMethod === "contraentrega"}
                      onChange={() => setPaymentMethod("contraentrega")}
                      disabled={deliveryOption === "envioProvincia"}
                    />
                    <label htmlFor="contraentrega">
                      Contraentrega (COD) - Solo Lima
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="yape-plin"
                      name="paymentMethod"
                      value="yape/plin"
                      checked={paymentMethod === "yape/plin"}
                      onChange={() => setPaymentMethod("yape/plin")}
                    />
                    <label htmlFor="yape-plin">Yape / Plin</label>
                  </div>
                </div>

                {/* Discount Field */}
                <div className="field-container">
                  <label htmlFor="codigoDescuento">Cód. Descuento</label>
                  <div className="input-group">
                    <div className="icon-block">
                      <FontAwesomeIcon icon={faTag} />
                    </div>
                    <input
                      type="text"
                      id="codigoDescuento"
                      value={codigoDescuento}
                      onChange={(e) => setCodigoDescuento(e.target.value)}
                      placeholder="Código (opcional)"
                    />
                  </div>
                </div>

                <textarea
                  placeholder="Agrega una nota (opcional)"
                  value={noteText}
                  onChange={(e) => setNoteText(e.target.value)}
                />
                <fieldset className="deNonefieldset">
                  <legend>Productos</legend>
                  <textarea
                    name="productos"
                    value={cartItems
                      .map(
                        (item) =>
                          `${item.titulo}, x ${item.cantidad}, ${item.item},${
                            item.categoria
                          },${item.precio}, ${obtenerImagen(item)}  `
                      )
                      .join("\n")}
                    readOnly
                  />
                </fieldset>
              </div>
              {mensaje ? (
                <button type="button" className="btn" disabled>
                  {mensaje}
                </button>
              ) : (
                <button type="button" onClick={crearPedido} className="btn">
                  Finalizar pedido
                </button>
              )}
            </Modal>
          </>
        )}
      </Modal>
    </div>
  );
}
